import { ChallengeKind, ChallengeResponse, RecaptchaType } from '../contexts/recaptcha';

export type ChallengeRequest = {
  // kebab-case for consistency with sign-in-service api
  'challenge-kind': ChallengeKind;
  token: { value: string };
  type: RecaptchaType;
};

export function toChallengeRequest(response?: ChallengeResponse | null): ChallengeRequest | null {
  if (!response) {
    return null;
  }

  return {
    'challenge-kind': response.challengeKind,
    token: { value: response.token },
    type: response.type,
  };
}
